import { createContext, useContext, useState } from 'react';

const SideNavSelectionDispatch = createContext();
const SideNavSelectionContext = createContext();

const SideNavSelectionProvider = ({ children }) => {
	const [sideNavSelection, setSideNavSelection] = useState({});
	return (
		<SideNavSelectionContext.Provider value={sideNavSelection}>
			<SideNavSelectionDispatch.Provider value={setSideNavSelection}>
				{children}
			</SideNavSelectionDispatch.Provider>
		</SideNavSelectionContext.Provider>
	);
};

const useSideNavSelectionState = () => {
	const context = useContext(SideNavSelectionContext);
	if (context === undefined) {
		throw new Error('useSideNavSelectionState must be used within a ClientSettingsProvider');
	}
	return context;
};

const useSideNavSelectionDispatch = () => {
	const context = useContext(SideNavSelectionDispatch);
	if (context === undefined) {
		throw new Error('useSideNavSelectionDispatch must be used within a ClientSettingsProvider');
	}
	return context;
};

export { SideNavSelectionProvider, useSideNavSelectionState, useSideNavSelectionDispatch };
